module.exports = __webpack_public_path__ + "img/introducePageSeven_show_seven.9baa3535.jpg";